var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#111","fillRule":"nonzero","d":"M1.718 5.804L.282 7.196l6.051 6.24 11.385-11.74L16.282.304l-9.949 10.26z"}));
}

Check.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14"};

module.exports = Check;

Check.default = Check;
